import React from 'react';
import ReportStyledWidgetWrapper from './ReportStyledWidgetWrapper';
import * as StaticViewBlocks from '@mono/static-view-blocks';

const StaticViewBlockContainer = ({ reportViewBlockType, viewblockState, date, timezone, onEditMarkdown }) => {
    const staticViewBlock = StaticViewBlocks[reportViewBlockType];
    const StaticViewBlockPreviewComponent = staticViewBlock.preview;
    return (
        <ReportStyledWidgetWrapper>
            <StaticViewBlockPreviewComponent staticBlockState={viewblockState} date={date} timezone={timezone} onEditMarkdown={onEditMarkdown} />
        </ReportStyledWidgetWrapper>
    );
};

export default ({ reportViewBlockType, viewblockState, date, timezone, onEditMarkdown }) => (
    <StaticViewBlockContainer
        reportViewBlockType={reportViewBlockType}
        viewblockState={viewblockState}
        date={date}
        timezone={timezone}
        onEditMarkdown={onEditMarkdown}
    />
);
